import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import MainLayout from '../components/MainLayout';
import TrainingTracks from './TrainingTracks';
import TrainingSessions from './TrainingSessions';
import TrainingAnalytics from './TrainingAnalytics';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`training-tabpanel-${index}`}
      aria-labelledby={`training-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const Training: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <MainLayout title="Training">
      <div className="p-2">
        <div className="mb-3">
          <h1 className="text-2xl font-bold text-gray-900">Training</h1>
          <p className="text-gray-600 mt-1">Manage training tracks, sessions, and view training analytics</p>
        </div>

        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={currentTab} onChange={handleTabChange} aria-label="training tabs">
            <Tab label="Training Tracks" id="training-tab-0" aria-controls="training-tabpanel-0" data-tutorial="training-tracks-tab" />
            <Tab label="Training Sessions" id="training-tab-1" aria-controls="training-tabpanel-1" data-tutorial="training-sessions-tab" />
            <Tab label="Analytics" id="training-tab-2" aria-controls="training-tabpanel-2" />
          </Tabs>
        </Box>

        <TabPanel value={currentTab} index={0}>
          <TrainingTracks />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <TrainingSessions />
        </TabPanel>

        <TabPanel value={currentTab} index={2}>
          <TrainingAnalytics />
        </TabPanel>
        </Box>
      </div>
    </MainLayout>
  );
};

export default Training;
